import React from 'react';
import {
    FETCH_FEEDBACK_REQUEST,
    FETCH_FEEDBACK_REQUEST_SUCCESS,
    FETCH_FEEDBACK_REQUEST_FAILER,
    CREATE_FEEDBACK_REQUEST,
    CREATE_FEEDBACK_REQUEST_SUCCESS,
    CREATE_FEEDBACK_REQUEST_FAILER,
    FETCH_LISITNG_DROPDOWN_REQUEST,
    FETCH_LISITNG_DROPDOWN_SUCCESS,
    FETCH_LISITNG_DROPDOWN_FAILER
} from './FeedbackActionTypes';

// Fetch Feedback

export const fetchFeedbackRequest = () => {
    return {
        type: FETCH_FEEDBACK_REQUEST
    };
}

export const fetchFeedbackRequestSuccess = (data: any) => {
    return {
        type: FETCH_FEEDBACK_REQUEST_SUCCESS,
        payload: data
    };
}

export const fetchFeedbackRequestFailer = (error: any) => {
    return {
        type: FETCH_FEEDBACK_REQUEST_FAILER,
        payload: error
    };
}



// Create Feedback

export const createFeedbackRequest = () => {
    return {
        type: CREATE_FEEDBACK_REQUEST
    };
}

export const createFeedbackRequestSuccess = (data: any) => {
    return {
        type: CREATE_FEEDBACK_REQUEST_SUCCESS,
        payload: data
    };
}

export const createFeedbackRequestFailer = (error: any) => {
    return {
        type: CREATE_FEEDBACK_REQUEST_FAILER,
        payload: error
    };
}

// Fetch dropdown list 

export const fetchFeedbackDropDownListRequest = () => {
    return {
        type: FETCH_LISITNG_DROPDOWN_REQUEST
    };
}

export const fetchFeedbackDropDownListSuccess = (data: any) => {
    return {
        type: FETCH_LISITNG_DROPDOWN_SUCCESS,
        payload: data
    };
}

export const fetchFeedbackDropDownListFailer = (error: any) => {
    return {
        type: FETCH_LISITNG_DROPDOWN_FAILER,
        payload: error
    };
}